import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiCheck } from "react-icons/fi";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form, Field } from "formik";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { FormHelperText } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { subscriptionDetail } from "../redux/slices/company/companySlice";
import * as Yup from "yup";
import { baseURL } from "../axios/AxiosAut";

const validationSchema = Yup.object({
  number_of_users: Yup.string().required("Required"),
  subscription_renewal_period: Yup.string().required("Required"),
});

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  root: {
    minWidth: 275,
    borderBlockColor: "#D2E4F0",
    borderRadius: "5px",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  pos: {
    marginBottom: 12,
    textAlign: "center",
  },
  user: {
    color: "blue",
    fontSize: 15,
    textAlign: "center",
  },
  price: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  peruser: {
    fontSize: "15",
    color: "grey",
    textAlign: "center",
  },
  pprice: {
    color: "blue",
    fontSize: 25,
    fontWeight: "bold",
    textAlign: "center",
  },
  button: {
    margin: theme.spacing(5),
    fontFamily: "Calibri",
    fontWeight: "bold",
    color: "White",
    fontSize: "15px",
    width: "100%",
    marginLeft: "auto",
  },
  listitem: {
    paddingTop: "0px",
  },
}));

type ButtonProp = {
  HandleNext: () => void;
};

export default function SubscriptionDetail(props: ButtonProp) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [Pakages, setPakages] = useState<any[]>([]);
  const [User, setUser] = useState(0);
  const [Price, setPrice] = useState(Number);
  const [pkgType, setpkgType] = useState("");
  const [TotalPrice, setTotalPrice] = useState(Number);
  const [RenewalPeriod, setRenewalPeriod] = useState(Number);

  const handleRenewalPeriod = (event) => {
    setRenewalPeriod(event.target.value);
  };

  useEffect(() => {
    axios
      .get(`${baseURL}company/get_packages/`)
      .then((res) => {
        console.log(res.data);
        setPakages(res.data);
      })
      .catch((error) => {});
    return () => {
      //cleanup
    };
  }, []);
  useEffect(() => {
    setTotalPrice(User * Price);
    console.log("total price", TotalPrice);
  }, [User, Price]);

  const handlePrice = (price, pkgType) => {
    setPrice(price);
    setpkgType(pkgType);
  };
  const handleChange = (event) => {
    setUser(event.target.value);
  };
  const initialValues = {
    number_of_users: User,
    package: pkgType,
    price_per_month: "",
    total_price: "",
    subscription_renewal_period: RenewalPeriod,
  };
  const onSubmit = (values) => {
    props.HandleNext();
    dispatch(
      subscriptionDetail({
        number_of_users: User,
        package: pkgType,
        price_per_month: Price,
        total_price: TotalPrice,
        subscription_renewal_period: RenewalPeriod,
      })
    );
  };
  return (
    <>
      <div className="container w-full mx-auto px-4">
      <div className="pl-8 my-8 text-black font-Montserrat">
        Select your package
      </div>
        <div className="grid lg:grid-cols-3 gap-3 my-4 md:grid-cols-1">
          
          {Pakages.map((pkg, index) => (
            <>
              <div
                className="card-body w-55 "
                onClick={() => {
                  handlePrice(pkg.price_per_user, pkg.package_type);
                }}
                key={index}
              >
                <div className="md:flex md:flex-col content-start items-center justify-items-start">
                  <h2 className="font-semibold mt-4 text-2xl">
                    {pkg.package_type}
                  </h2>
                  <h1 className="text-blue-200">
                    (min {pkg.minimum_users} User)
                  </h1>
                  <div className="flex items-center mt-2 ">
                    <h2 className="text-blue-200 text-3xl font-bold">
                      ${pkg.price_per_user}
                    </h2>
                    <h1>/user</h1>
                  </div>
                  <h1>Billed Monthly</h1>
                </div>
                {pkg.workforce_instruction_scheduling && (
                  <div className="md:flex items-start justify-start px-2 mt-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h2>Work Force instruction scheduling</h2>
                  </div>
                )}
                {pkg.management_of_training && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Management of workfore Training</h1>
                  </div>
                )}
                {pkg.training && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1> Training</h1>
                  </div>
                )}
                {pkg.quality_control && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Quality control</h1>
                  </div>
                )}
                {pkg.supply_chain_management && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Supply chain management</h1>
                  </div>
                )}
                {pkg.bill_of_materials && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Bill of material</h1>
                  </div>
                )}
                {pkg.warehouse_management && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Warehouse management</h1>
                  </div>
                )}
                {pkg.warehouse_design && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Warehouse design</h1>
                  </div>
                )}
                {pkg.tracking && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Tracking</h1>
                  </div>
                )}
                {pkg.chat_support && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Chat support</h1>
                  </div>
                )}
                {pkg.plan_of_action_provided && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Plan of action provided</h1>
                  </div>
                )}
                {pkg.call_support && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Call support</h1>
                  </div>
                )}
                {pkg.installation_support && (
                  <div className="md:flex items-start justify-start px-2">
                    <svg
                      className="mr-4"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                        stroke="#26F32E"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                        fill="#26F32E"
                      />
                    </svg>
                    <h1>Installation support by our team</h1>
                  </div>
                )}
                <button
                  type="submit"
                  className="mt-8  font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow "
                >
                  Select
                </button>
              </div>
            </>
          ))}
        </div>
      </div>
      <div className="pl-8 my-8 text-gray-50 font-Montserrat">
        Add warehouse management
      </div>
      <div className=" flex flex-wrap bg-white shadow-lg rounded-xl px-4 py-4 my-8 text-gray-50">
        <div className="flex-4 flex flex-wrap">
          <svg
            className=""
            width="100"
            height="79"
            viewBox="0 0 100 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M97.2017 46.7235L50.7638 10.2003C50.4654 9.97489 50.0924 9.97489 49.794 10.2003L2.75933 46.7235C2.57284 46.8738 2.46094 47.0993 2.46094 47.3623V77.4601C2.46094 77.911 2.79663 78.2491 3.24423 78.2491H29.2793C29.7269 78.2491 30.0626 77.911 30.0626 77.4601V45.5962C30.0626 44.0181 31.3308 42.7029 32.9346 42.7029H66.7653C68.3319 42.7029 69.6373 43.9805 69.6373 45.5962V77.4601C69.6373 77.911 69.973 78.2491 70.4206 78.2491H96.7168C97.1644 78.2491 97.5001 77.911 97.5001 77.4601V47.3623C97.5001 47.0993 97.3882 46.8738 97.2017 46.7235Z"
              fill="#79E2A2"
            />
            <path
              d="M1.49198 46.0109L49.7948 8.39807C50.0932 8.17262 50.4662 8.17262 50.7646 8.39807L98.7318 45.9733C99.254 46.3867 100 46.0109 100 45.3346V38.4583C100 38.1953 99.8881 37.9698 99.7016 37.8195L50.7646 0.169089C50.4662 -0.0563629 50.0932 -0.0563629 49.7948 0.169089L0.298396 38.4207C0.111899 38.571 0 38.834 0 39.0595L0.223797 45.4097C0.223797 46.0861 0.969787 46.4242 1.49198 46.0109Z"
              fill="#79E2A2"
            />
            <path
              d="M67.3261 47.8159H31.6677C31.4812 47.8159 31.332 47.6656 31.332 47.4778V45.6741C31.332 45.4862 31.4812 45.3359 31.6677 45.3359H67.3261C67.5126 45.3359 67.6618 45.4862 67.6618 45.6741V47.4778C67.6245 47.6656 67.4753 47.8159 67.3261 47.8159Z"
              fill="#79E2A2"
            />
            <path
              d="M47.9689 66.6412H35.2498C35.0633 66.6412 34.9141 66.4909 34.9141 66.303V58.1116C34.9141 57.9237 35.0633 57.7734 35.2498 57.7734H47.9689C48.1554 57.7734 48.3046 57.9237 48.3046 58.1116V66.303C48.2673 66.5285 48.1181 66.6412 47.9689 66.6412Z"
              fill="#79E2A2"
            />
            <path
              d="M47.9689 77.6505H35.2498C35.0633 77.6505 34.9141 77.5002 34.9141 77.3123V69.1585C34.9141 68.9706 35.0633 68.8203 35.2498 68.8203H47.9689C48.1554 68.8203 48.3046 68.9706 48.3046 69.1585V77.3499C48.2673 77.5378 48.1181 77.6505 47.9689 77.6505Z"
              fill="#79E2A2"
            />
            <path
              d="M63.5236 77.6505H50.8044C50.6179 77.6505 50.4688 77.5002 50.4688 77.3123V69.1585C50.4688 68.9706 50.6179 68.8203 50.8044 68.8203H63.5236C63.7101 68.8203 63.8593 68.9706 63.8593 69.1585V77.3499C63.8593 77.5378 63.7101 77.6505 63.5236 77.6505Z"
              fill="#79E2A2"
            />
          </svg>
          <div>
          <h1 className="text-xl font-semibold font-Montserrat mt-4 text-blue-200 ml-4">
            {" "}
            Warehouse Management Package
          </h1>
          <h1 className="text-base font-semibold font-Montserrat text-gray-50 ml-8">
            {" "}
            What is the benefit?
          </h1>
          </div>
        </div>
        <div className="flex-1 border-l-1 border-gray-50">
        <button
                  type="submit"
                  className="mt-4 mx-2 font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-lg px-4 py-2 flex flex-grow "
                >
                  $2000
                </button>
        </div>
      </div>

      <div className="min-h-full w-4/5 mx-auto flex items-center justify-center sm:px-6 lg:px-8 bg-white pb-8 shadow-lg rounded-xl">
        <div className="max-w-3xl w-full space-y-8">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnMount
          >
            <Form className="space-y-6">
              <div className="grid">
                <Field name="number_of_users">
                  {(props) => {
                    const { field, form, meta } = props;
                    console.log("field", field);
                    return (
                      <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-blue-200 font-Montserrat font-medium flex flex-wrap"><svg className="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7274 20.4471C19.2716 19.1713 18.2672 18.0439 16.8701 17.2399C15.4729 16.4358 13.7611 16 12 16C10.2389 16 8.52706 16.4358 7.12991 17.2399C5.73276 18.0439 4.72839 19.1713 4.27259 20.4471" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
<circle cx="12" cy="8" r="4" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
</svg>
 Users</label>
                        
                        <input
                          onChange={handleChange}
                          value={User}
                          type="number"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Users"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
              </div>
              <Field name="price_per_month">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <div className="my-2 flex flex-wrap">
                      <label className="mt-4 w-1/6 text-blue-200 font-Montserrat font-medium flex flex-wrap break-words"><svg className="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="6" width="18" height="15" rx="2" stroke="#1F78B4" stroke-width="2"/>
<path d="M4 11H20" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
<path d="M9 16H15" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
<path d="M8 3L8 7" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
<path d="M16 3L16 7" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
</svg>
Price per month</label>
                      <input
                        {...field}
                        value={Price}
                        type="number"
                        className="border-2 rounded-lg relative block w-1/2 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors"
                        placeholder="Price Per Month"
                      ></input>
                      <Select
                          {...field}
                          className="w-1/4 rounded-lg ml-4 "
                          onChange={handleRenewalPeriod}
                          value={RenewalPeriod}
                          placeholder="Subscription Renewal Period"
                        >
                          <MenuItem value={1}>
                            <div style={{ textAlign: "initial" }}>1 Month</div>
                          </MenuItem>
                          <MenuItem value={2}>
                            <div style={{ textAlign: "initial" }}>2 Month</div>
                          </MenuItem>
                          <MenuItem value={3}>
                            <div style={{ textAlign: "initial" }}>3 Month</div>
                          </MenuItem>
                          <MenuItem value={4}>
                            <div style={{ textAlign: "initial" }}>4 Month</div>
                          </MenuItem>
                          <MenuItem value={5}>
                            <div style={{ textAlign: "initial" }}>5 Month</div>
                          </MenuItem>
                          <MenuItem value={6}>
                            <div style={{ textAlign: "initial" }}>6 Month</div>
                          </MenuItem>
                          <MenuItem value={7}>
                            <div style={{ textAlign: "initial" }}>7 Month</div>
                          </MenuItem>
                          <MenuItem value={8}>
                            <div style={{ textAlign: "initial" }}>8 Month</div>
                          </MenuItem>
                          <MenuItem value={9}>
                            <div style={{ textAlign: "initial" }}>9 Month</div>
                          </MenuItem>
                          <MenuItem value={10}>
                            <div style={{ textAlign: "initial" }}>10 Month</div>
                          </MenuItem>
                          <MenuItem value={11}>
                            <div style={{ textAlign: "initial" }}>11 Month</div>
                          </MenuItem>
                          <MenuItem value={12}>
                            <div style={{ textAlign: "initial" }}>12 Month</div>
                          </MenuItem>
                        </Select>
                    </div>
                  );
                }}
              </Field>
              <Field name="total_price">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <div className="my-2 flex flex-wrap">
                      <label className="my-4 w-1/6 text-blue-200 font-Montserrat font-medium flex flex-wrap break-words "><svg className="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z" stroke="#1F78B4" stroke-width="2"/>
<path d="M12 8L12 16" stroke="#1F78B4" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
<path d="M16 12L8 12" stroke="#1F78B4" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
</svg>
 Price after VAT</label>
                      <input
                        {...field}
                        value={TotalPrice}
                        type="number"
                        className="border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors"
                        placeholder="Price After VAT"
                      ></input>
                    </div>
                  );
                }}
              </Field>
              <Field name="total_price">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <div className="my-2 flex flex-wrap">
                      <label className="my-4 w-1/6 text-blue-200 font-Montserrat font-medium flex flex-wrap">% Discount Code </label>
                      <input
                        {...field}
                        value={TotalPrice}
                        type="number"
                        className="border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors"
                        placeholder="if any?"
                      ></input>
                    </div>
                  );
                }}
              </Field>
             
              {/* <Field>
                {(props) => {
                  const { field, form, meta } = props;
                  const { isSubmitting } = form;
                  return (
                    <button
                      type="submit"
                      {...(form.isValid
                        ? {
                            className:
                              "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow ",
                          }
                        : {
                            disabled: true,
                            className:
                              "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow opacity-50 cursor-not-allowed",
                          })}
                    >
                      Next
                    </button>
                  );
                }}
              </Field> */}
            </Form>
          </Formik>
        </div>
      </div>
      <button
                      type="submit"
                      
                            className=
                              "font-Montserrat font-semibold mt-8 text-white mx-auto flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-2/3 rounded-sm px-4 py-2 flex flex-grow "
                    
                           
                    >
                      Next
                    </button>
    </>
  );
}
